module.exports = __webpack_public_path__ + "media/images/LessonPlan-e8444cd096e59d0676e3c8c6bef86bd2.svg";